import React, { Fragment, type JSX } from 'react';

const interleave = (arr: string[], thing: JSX.Element) =>
  [].concat(...arr.map(n => [n, thing])).slice(0, -1);

export const newlinesToLineBreaks = (text: string) => interleave(text.split('\n'), <br />);

export const addBreakLineTag = (item: string, index: number) => (
  <Fragment key={index}>{item}</Fragment>
);
